import { DataTableWrapper } from "@/Components/datatable/data-table";
import { Dialog, DialogHeader, DialogContent, DialogTitle } from "@/Components/ui/dialog";
import { PlanTableColumnVisibility } from '@/Pages/Plan';
import { getTaskColumns } from './columns';
import { Task } from "../Plan";

interface PlanTableProps {
    tasks: any[];
    isLoading: boolean;
    viewOnly: boolean;
    columnVisibility: PlanTableColumnVisibility;
    columnDisplayNames: [string, string][];
    confirmDeleteTasks: (taskIds: number[]) => void;
    editTask: (taskId: number) => void;
    groupCompleteTasks: (taskIds: number[]) => void;
    groupActions: {
        name: string;
        action: (selectedRows: any[]) => void;
    }[]
    dialogOpen: boolean;
    setDialogOpen: (open: boolean) => void;
    dialogTitle: string;
    dialogContent: JSX.Element | null;
}

const PlanTable = ({ tasks,
    isLoading,
    viewOnly,
    columnVisibility,
    columnDisplayNames,
    confirmDeleteTasks,
    editTask,
    groupCompleteTasks,
    groupActions,
    dialogOpen,
    setDialogOpen,
    dialogTitle,
    dialogContent }: PlanTableProps) => {
    return (
        <>
            <DataTableWrapper
                columns={getTaskColumns(
                    confirmDeleteTasks,
                    editTask,
                    groupCompleteTasks,
                )}
                data={tasks}
                setData={() => {}} // No setData provided, assuming tasks are managed externally
                loading={isLoading}
                viewOnly={viewOnly}
                columnVisibility={columnVisibility}
                columnDisplayNames={columnDisplayNames}
                table_title="Tasks"
                groupActions={groupActions}
                onRowClick={(row) => {editTask((row.original as Task).id)}}
            />
            <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
                <DialogContent className="">
                    <DialogHeader className="">
                        <DialogTitle>{dialogTitle}</DialogTitle>
                    </DialogHeader>
                    {dialogContent}
                </DialogContent>
            </Dialog>
        </>
    )
}

export default PlanTable